export const CONDITION_MATCH_TYPES = [
  'is equal to',
  'contains',
  'does not exist',
  'matches regular expression'
];

export const ACTION_MATCH_TYPES = [
  'is equal to',
  'contains',
  'matches regular expression'
];



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/app/multi-editor/shared/constants/match-types.ts